import { Module } from 'vuex';

import { ConfigState } from './types';
import { StoreState } from '@/types';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import { load } from '@/helpers/storage';

const state: ConfigState = {
  beToken: load('token', ''),
};

const module: Module<ConfigState, StoreState> = {
  namespaced: true,

  state,
  getters,
  mutations,
  actions,
};

export default module;
